var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { AclAction } from 'shared/domains/apollo/generated/types';
export function calculateACLDiff(prev, next, key) {
    if (!prev || !next) {
        return [];
    }
    return next.reduce((acc, nextACL) => {
        const sourceACL = prev.find((acl) => acl[key] === nextACL[key]);
        const { actions: nextActions } = nextACL, rest = __rest(nextACL, ["actions"]);
        const hasChange = nextActions.toSorted().join(',') !== (sourceACL === null || sourceACL === void 0 ? void 0 : sourceACL.actions.toSorted().join(','));
        const isPrevNoAccess = (sourceACL === null || sourceACL === void 0 ? void 0 : sourceACL.actions.includes(AclAction.Traverse)) || !(sourceACL === null || sourceACL === void 0 ? void 0 : sourceACL.actions.length);
        const isNextNoAccess = nextActions.includes(AclAction.Traverse);
        if (!hasChange || (isNextNoAccess && isPrevNoAccess)) {
            return acc;
        }
        const diffItem = Object.assign(Object.assign({}, rest), { actions: {
                prev: (sourceACL === null || sourceACL === void 0 ? void 0 : sourceACL.actions) || [],
                next: nextACL.actions,
            } });
        return [...acc, diffItem];
    }, []);
}
